<template>
  <SectionPageShell
    section="packages"
    title="Pakete"
  >
    <PackagePaymentMethods v-if="!hasActiveIndividualPackage" />

    <PackagesStatusOverview
      :primary-rows="primaryStatusRows"
      :secondary-rows="secondaryStatusRows"
      :total-active-count="activePackages.length"
      :reactivating-ids="reactivatingIds"
      :route-query="$route.query"
      @continue-recurring="continueRecurring"
      @scroll-to-row="scrollToRow"
    />

    <PackagesCatalog
      v-if="!hasActiveIndividualPackage"
      :rows="packageRows"
      :loading="packagesStore.loading"
      :route-query="$route.query"
    />
  </SectionPageShell>
</template>

<script>
import Swal from 'sweetalert2'
import PackagePaymentMethods from '@/components/packages/PackagePaymentMethods.vue'
import PackagesCatalog from '@/components/packages/PackagesCatalog.vue'
import PackagesStatusOverview from '@/components/packages/PackagesStatusOverview.vue'
import SectionPageShell from '@/components/base_type/SectionPageShell.vue'
import {usePackagesStore} from '@/stores/packages'
import {useUserStore} from '@/stores/user'
import {
  buildPackageRows,
  getPackageAssignmentId,
  hasActiveIndividualPackage,
  splitStatusRows,
} from '@/utils/packagePolicy'

export default {
  name: 'PackagesLanding',
  components: {
    PackagePaymentMethods,
    PackagesCatalog,
    PackagesStatusOverview,
    SectionPageShell,
  },
  setup() {
    return {
      packagesStore: usePackagesStore(),
      userStore: useUserStore(),
    }
  },
  data() {
    return {
      reactivatingIds: [],
    }
  },
  computed: {
    activePackages() {
      return this.userStore.user.organisation?.active_packages || []
    },
    packageRows() {
      return buildPackageRows(this.activePackages, this.packagesStore.items)
    },
    statusRows() {
      return splitStatusRows(this.packageRows, this.activePackages)
    },
    primaryStatusRows() {
      return this.statusRows.primary
    },
    secondaryStatusRows() {
      if (this.hasActiveIndividualPackage) {
        return []
      }
      return this.statusRows.secondary
    },
    hasActiveIndividualPackage() {
      return hasActiveIndividualPackage(this.activePackages)
    },
  },
  created() {
    this.packagesStore.index()
  },
  methods: {
    async continueRecurring(pkg) {
      const assignmentId = getPackageAssignmentId(pkg)
      if (!assignmentId) {
        await Swal.fire('Fehler', 'Paketzuordnung fehlt.', 'error')
        return
      }

      this.reactivatingIds = [...this.reactivatingIds, assignmentId]

      try {
        const kdnr = this.userStore.user?.organisation?.kdnr || this.$route.query.kdnr
        await this.packagesStore.apiClientV2.post(`/payments/${assignmentId}/continue_recurring`, {
          ...(kdnr ? {kdnr} : {}),
        })

        await this.userStore.apiUserData()
        await this.packagesStore.index()
        await Swal.fire('Erfolg', 'Das Abonnement wurde fortgesetzt.', 'success')
      } catch (error) {
        const message = error?.response?.data?.message || error?.response?.data?.error || 'Fortsetzen fehlgeschlagen.'
        await Swal.fire('Fehler', message, 'error')
      } finally {
        this.reactivatingIds = this.reactivatingIds.filter((id) => id !== assignmentId)
      }
    },
    scrollToRow(key) {
      const element = document.getElementById(`package-row-${key}`)
      if (element) {
        element.scrollIntoView({behavior: 'smooth', block: 'start'})
      }
    },
  },
}
</script>
